import { Button, styled } from '@mui/material'
import { CommonButtonProps } from './StandardButton'
import { Icon } from 'hello-design-system'

const StyledButton = styled(Button)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        height: theme.spacing(5),
        padding: theme.spacing(1)
    },
    '&.MuiButton-root': {
        borderRadius: '16px',
        height: '48px',
        padding: '14px 16px',
        '&.MuiButton-colorSecondary': {
            backgroundColor: theme.palette.background?.default,
            fontWeight: '400 !important',
            color: theme.palette.grey?.[700],
            '.MuiSvgIcon-root': {
                fill: theme.palette.grey?.[800]
            }
        }
    }
}))

const EndCallButton: React.FC<Omit<CommonButtonProps, 'active'> & { text: string }> = ({ id, disabled, onClick, text }) => (
    <StyledButton
        id={id}
        color='error'
        startIcon={<Icon iconName='CallEndRounded' />}
        disabled={disabled}
        onClick={onClick}
        size='large'
        variant='contained'
    >
        {text}
    </StyledButton>
)

export { EndCallButton }
